module.exports = __webpack_public_path__ + "img/twittericon.777f7d62.svg";